import PropTypes from 'prop-types';
import React from 'react';
import Sold from './sold';

const ResultView = ({filter, listings}) => {
  const results = [];
  listings.forEach((listing, index) => {
    if (index%3 === 0) {
      results.push(<div className="clear-fix until-sm" key={"clearfix-sm-" + index}></div>);
    }
    if (index%2 === 0) {
      results.push(<div className="clear-fix hidden visible-xs" key={"clearfix-xs-" + index}></div>);  
    }
    results.push(<Sold listing={listing} filter={filter} index={index} key={index}/>);
  });

  return (
    <div className="results-view" id="results-title">
      {results}
    </div>
  );
};

ResultView.propTypes = {
  filter: PropTypes.object.isRequired,
  listings: PropTypes.array.isRequired
};

export default ResultView;



// WEBPACK FOOTER //
// ./src/components/solds/result-view.js